import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DashboardLayout from './components/DashboardLayout';
import DashboardUnified from './pages/DashboardUnified';
import FicheClient from './pages/FicheClient';
import EligibilityRules from './pages/EligibilityRules';
import AdminCodesNAF from './pages/AdminCodesNAF';
import AdminBaremesTICFE from './pages/AdminBaremesTICFE';
import AdminMatriceTauxOptimises from './pages/AdminMatriceTauxOptimises';
import CreateAnalyseTURPE from './pages/CreateAnalyseTURPE';
import RapportDigital from './pages/RapportDigital';
import RapportTURPE from './pages/RapportTURPE';
import RapportTURPEMulti from './pages/RapportTURPEMulti';
import RapportTICFE from './pages/RapportTICFE';
import CreateRapport from './pages/CreateRapport';
import CreateRapportTICGN from './pages/CreateRapportTICGN';
import RapportTICGN from './pages/RapportTICGN';
import RapportShareView from './pages/RapportShareView';
import AdminBaremesTICGN from './pages/AdminBaremesTICGN';
import AdminTarifsCerfa from './pages/AdminTarifsCerfa';
import AdminCodesNAFTICGN from './pages/AdminCodesNAFTICGN';
import AdminTarifsCerfaTicgn from './pages/AdminTarifsCerfaTicgn';
import AdminCommerciaux from './pages/AdminCommerciaux';
import AdminCoefficientsTURPE from './pages/AdminCoefficientsTURPE';
import AdminComposantesTURPE from './pages/AdminComposantesTURPE';
import AdminReactifTURPE from './pages/AdminReactifTURPE';
import AdminTarifsEnedis from './pages/AdminTarifsEnedis';
import AdminRecomputeDepassements from './pages/AdminRecomputeDepassements';
import AdminIcpeRubriques from './pages/AdminIcpeRubriques';
import AdminTarifsReduitsTICGN from './pages/AdminTarifsReduitsTICGN';
import AdminTarifsFiscauxEnergies from './pages/AdminTarifsFiscauxEnergies';
import AdminCasDoubleUsageTICGN from './pages/AdminCasDoubleUsageTICGN';
import AdminAuditLogs from './pages/AdminAuditLogs';
import AdminBackup from './pages/AdminBackup';
import Users from './pages/Users';
import TURPEMassif from './pages/TURPEMassif';
import Account from './pages/Account';
import Analyses from './pages/Analyses';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/rapports/:id" element={<RapportDigital />} />
          <Route path="/rapports/ticfe/:id" element={<RapportTICFE />} />
          <Route path="/rapports/ticfe/preview" element={<RapportTICFE />} />
          <Route path="/rapports/turpe/:id" element={<RapportTURPE />} />
          <Route path="/rapports/turpe/preview" element={<RapportTURPE />} />
          <Route path="/rapports/turpe/multi/:id" element={<RapportTURPEMulti />} />
          <Route path="/rapports/turpe/multi/preview" element={<RapportTURPEMulti />} />
          <Route path="/rapports/ticgn/:id" element={<RapportTICGN />} />
          <Route path="/share/:token" element={<RapportShareView />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardUnified />} />
            <Route path="analyses" element={<Analyses />} />
            <Route path="account" element={<Account />} />
            <Route path="entreprises/:siren" element={<FicheClient />} />
            <Route path="rapports/create" element={<CreateRapport />} />
            <Route path="rapports/ticgn/create" element={<CreateRapportTICGN />} />
            <Route path="analyses/turpe/create" element={<CreateAnalyseTURPE />} />
            <Route path="turpe/create" element={<CreateAnalyseTURPE />} />
            <Route path="eligibility-rules" element={<EligibilityRules />} />
            <Route path="admin/codes-naf" element={<AdminCodesNAF />} />
            <Route path="admin/baremes-ticfe" element={<AdminBaremesTICFE />} />
            <Route path="admin/baremes-ticgn" element={<AdminBaremesTICGN />} />
            <Route path="admin/codes-naf-ticgn" element={<AdminCodesNAFTICGN />} />
            <Route path="admin/tarifs-cerfa-ticgn" element={<AdminTarifsCerfaTicgn />} />
            <Route path="admin/tarifs-cerfa" element={<AdminTarifsCerfa />} />
            <Route path="admin/matrice-taux" element={<AdminMatriceTauxOptimises />} />
            <Route path="admin/coefficients-turpe" element={<AdminCoefficientsTURPE />} />
            <Route path="admin/composantes-turpe" element={<AdminComposantesTURPE />} />
            <Route path="admin/reactif-turpe" element={<AdminReactifTURPE />} />
            <Route path="admin/tarifs-enedis" element={<AdminTarifsEnedis />} />
            <Route path="admin/recompute-depassements" element={<AdminRecomputeDepassements />} />
            <Route path="admin/icpe-rubriques" element={<AdminIcpeRubriques />} />
            <Route path="admin/tarifs-reduits-ticgn" element={<AdminTarifsReduitsTICGN />} />
            <Route path="admin/tarifs-fiscaux-energies" element={<AdminTarifsFiscauxEnergies />} />
            <Route path="admin/cas-double-usage-ticgn" element={<AdminCasDoubleUsageTICGN />} />
            <Route path="admin/audit-log" element={<AdminAuditLogs />} />
            <Route path="admin/backup" element={<AdminBackup />} />
            <Route path="admin/commerciaux" element={<AdminCommerciaux />} />
            <Route path="users" element={<Users />} />
            <Route path="turpe-massif" element={<TURPEMassif />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
